import * as React from 'react';

const AmountToilets = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={18} height={21} viewBox="0 0 18 21" {...props}>
        <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.3}
        >
            <path d="M12.125 11.002h3.75c.69 0 1.25-.537 1.25-1.2v-7.2c0-.662-.56-1.2-1.25-1.2h-2.5c-.69 0-1.25.538-1.25 1.2zM2.125 8.602c-.69 0-1.25.538-1.25 1.2 0 .663.56 1.2 1.25 1.2h10v-2.4zM14.167 13.28c1.019-.328 1.706-1.244 1.706-2.276H2.125c0 2.48 1.448 4.752 3.75 5.88l-.625 2.52h8.125v-4.976a1.19 1.19 0 0 1 .792-1.148" />
        </g>
    </svg>
);
export default AmountToilets;
